import { type Actor } from '@campai/lib-common/entities'
import { hasAnyAdminOrganizationAccess } from '@campai/lib-common/utils/organization'

import { appState } from '@/appState'

export const canReadFeedback = () =>
    hasAnyAdminOrganizationAccess(appState.user) || appState.hasSystemPermission('feedback.admin')

export const canCreateFeedbackContent = () =>
    hasAnyAdminOrganizationAccess(appState.user) || appState.hasSystemPermission('feedback.admin')

export const canModerateFeedbackContent = () => appState.hasSystemPermission('feedback.admin')

export const isOwnFeedbackContent = (createdBy: Actor | string | null | undefined) => {
    if (!createdBy || (typeof createdBy !== 'string' && (createdBy.type !== 'user' || !createdBy.userId))) {
        return false
    }

    if (typeof createdBy === 'string') {
        return createdBy === appState.user.userId
    }

    return createdBy.type === 'user' && !!createdBy.userId && createdBy.userId === appState.user.userId
}
